import { ConfirmPopup } from '~/commonComponents';

interface IRegenerateConfirmDialogProps {
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const RegenerateConfirmDialog = ({
  isLoading,
  onClose,
  onConfirm,
}: IRegenerateConfirmDialogProps) => (
  <ConfirmPopup
    title="Want a fresh draft?"
    description="Regenerating will write a brand-new job description from your details and replace the edits you've made. No worries — you can tweak the new version however you like."
    descriptionStyle={{ marginBottom: 28, width: '100%', paddingInline: 20 }}
    leftButtonText="Keep my version"
    leftButtonAction={onClose}
    leftButtonDisabled={isLoading}
    rightButtonText="Regenerate"
    rightButtonAction={onConfirm}
    rightButtonLoading={isLoading}
  />
);
